import React from "react";
import { RouterConfig } from "@shared/lib/routerConfig";
import { NoComparisonsIcon } from "@shared/ui/Icon/ui/Statuses/NoComparisonsIcon";
import { NoComparisonsTexts } from "./constants";
import classes from "./NoComparisons.module.scss";

export const NoComparisons = () => {
    return (
        <div className={classes.NoComparisons}>
            <NoComparisonsIcon className={classes.NoComparisons__image} />
            <div className={classes.NoComparisons__content}>
                <h2 className={classes.NoComparisons__title}>{NoComparisonsTexts.TITLE}</h2>
                <p className={classes.NoComparisons__text}>{NoComparisonsTexts.DESCRIPTION}</p>
                <a className={classes.NoComparisons__link} href={RouterConfig.CATALOG}>
                    {NoComparisonsTexts.LINK_TEXT}
                </a>
            </div>
        </div>
    );
};